<template>
	<div class="contact">
		<div class="contact_cont">
			<div class="crumbs">当前位置：论坛首页-联系我们</div>
			<div class="contact_list">
				<div class="map">
					<img src="../../assets/wbanner_50.png" alt="">
				</div>
				<div class="info">
					<div class="tilte">中国首席经济学家论坛</div>
					<div class="tilte_en">
						<div class="te_list"><span>C</span>HINA</div>
						<div class="te_list"><span>C</span>HIEF</div>
						<div class="te_list"><span>E</span>CONOMIST</div>
						<div class="te_list"><span>F</span>ORUM</div>
					</div>
					<div class="location">组委会秘书处 中国·上海</div>
					<div class="address">
						<div class="name"><img src="../../assets/wbanner_51.png" alt="">公司地址</div>
						<div class="text">上海市虹口区东大名路1098号浦江国际金融广场806-7室（秘书处）</div>
					</div>
					<div class="address">
						<div class="name"><img src="../../assets/wbanner_52.png" alt="">公司电话</div>
						<div class="text">+86-21-61110219</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'contact',
		data() {
			return {}
		}
	}
</script>

<style>
	.contact .crumbs {
		width: 1200px;
		margin: 0 auto;
		margin-top: 30px;
		font-size: 16px;
		color: #999999;
	}

	.contact .contact_list {
		width: 1200px;
		margin: 0 auto;
		margin-top: 40px;
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;
		padding-bottom: 30px;
		align-items: center;
	}

	.contact .contact_list .map {
		width: 50%;
	}

	.contact .contact_list .info {
		width: 46%;
	}

	.contact .contact_list .info .tilte {
		color: #333;
		font-size: 24px;
		font-weight: bold;
		margin-bottom: 10px;
		margin-top: 30px;
	}

	.contact .contact_list .info .tilte_en {
		display: flex;
		flex-wrap: wrap;
		margin-bottom: 15px;
	}
	.contact .contact_list .info .tilte_en .te_list{
		font-size:18px;
		color: #333;
		margin-right: 3px;
		font-weight: bold;
	}
	.contact .contact_list .info .tilte_en .te_list span{
		color: #dd1010;
	}
	.contact .contact_list .info .location{
		font-size:18px;
		color: #333;
		margin-bottom: 20px;
	}
	.contact .contact_list .info .address{
		margin-bottom: 25px;
	}
	.contact .contact_list .info .address .name{
		font-size: 18px;
		color: #333;
		font-weight: bold;
	}
	.contact .contact_list .info .address .name img{
		vertical-align: middle;
		margin-top: -3px;
		margin-right: 15px;
	}
	.contact .contact_list .info .address .text{
		margin-left: 61px;
		color: #333;
		font-size: 16px;
		line-height: 30px;
	}
	@media screen and (max-width: 1400px){
		.contact .crumbs {
		    width: 900px;
		    margin-top: 20px;
		    font-size: 16px;
		}
		.contact .contact_list {
		    width: 900px;
		    margin-top: 20px;
		    padding-bottom: 20px;
		}
		.contact .contact_list .map img{
			width: 100%;
			height: 100%;
		}
	}
	@media screen and (max-width: 1000px){
		.contact .crumbs{
			width: 750px;
			margin-top: 10px;
			font-size: 16px;
		}
		.contact .contact_list {
		    width: 750px;
		    margin-top: 20px;
		    padding-bottom: 20px;
		}
	}
	@media screen and (max-width: 768px){
		.contact{
			margin-top: 80px;
		}
		.contact .crumbs{
			width: 98%;
			margin-top: 0px;
			font-size: 14px;
		}
		.contact .contact_list {
		   width: 98%;
		    margin-top: 10px;
		    padding-bottom: 10px;
		}
		.contact .contact_list .map{
			width: 100%;
		}
		
		.contact .contact_list .info{
			width: 100%;
		}
		.contact .contact_list .info .tilte {
		    font-size: 18px;
		    margin-bottom: 5px;
		    margin-top: 10px;
		}
		.contact .contact_list .info .tilte_en {
		    font-size: 14px;
		    margin-bottom: 5px;
		}
		.contact .contact_list .info .location {
		    font-size: 16px;
		    color: #333;
		    margin-bottom: 15px;
		}
		.contact .contact_list .info .address .name img{
			zoom: 0.6;
		}
		.contact .contact_list .info .address .name {
		    font-size: 16px;
		    color: #333;
		    font-weight: bold;
		}
		.contact .contact_list .info .address .text {
		    margin-left: 35px;
		    color: #333;
		    font-size: 14px;
		    line-height: 30px;
		}
		.contact .contact_list .info .address {
		    margin-bottom: 15px;
		}
	}
</style>